import React from 'react'
import Trns from 'src/localization/Trns'

export const valueIsEmpty =
  (message?: string) =>
  (val?: unknown): React.ReactElement | undefined =>
    val === undefined ? (
      <Trns source={message !== undefined ? message : 'Must not be blank'} />
    ) : undefined
